import { clsx } from "clsx";

import Spinner from "./Spinner";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "danger" | "outline";
  size?: "sm" | "md";
  loading?: boolean;
  children: React.ReactNode;
}

const baseClasses =
  "btn-custom inline-flex items-center justify-center border font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

const variantClasses = {
  primary: "border-transparent bg-dobu-orange text-white hover:bg-dobu-orange-focus focus:ring-dobu-orange",
  danger: "border-transparent bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
  outline: "border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-dobu-orange",
};

const sizeClasses = {
  sm: "px-2 py-1 text-xs",
  md: "px-4 py-2 text-sm",
};

const Button = ({ children, className, variant = "primary", size = "md", loading = false, ...props }: ButtonProps) => {
  return (
    <button
      className={clsx(baseClasses, variantClasses[variant], sizeClasses[size], className)}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && <Spinner className={size === "sm" ? "w-3 h-3 mr-1 text-white" : "w-5 h-5 mr-2 -ml-1 text-white"} />}
      {children}
    </button>
  );
};

export default Button;
